var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "view-point-green" }, [
    _c("dl", [
      _c("dt", [
        _c("img", {
          staticClass: "mb10 review-icon",
          attrs: {
            src: _vm.userOfferImageUrlForSp + "/reviews.png",
            alt: "reviews",
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "fs14 fwB" }, [
          _c(
            "a",
            { staticClass: "pb5 text-black", attrs: { target: "_blank" } },
            [
              _c(
                "span",
                {
                  staticClass: "fs14 fwB",
                  attrs: { "data-test": "company-name" },
                },
                [_vm._v(_vm._s(_vm.companyName))]
              ),
              _vm._v(
                "\n          社員からの評判・口コミをチェック！\n        "
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "dd",
        [
          _vm._l(_vm.realIntentions, function (realIntention, i) {
            return [
              _c(
                "div",
                { key: "real-intention-" + i, staticClass: "three-line" },
                [
                  _c("p", [
                    _c("span", [
                      _c("img", {
                        staticClass: "circle-icon",
                        attrs: {
                          src: _vm.userOfferImageUrlForSp + "/icn_circle.png",
                          alt: "circle",
                        },
                      }),
                    ]),
                    _c("span", { staticClass: "overflow" }, [
                      _vm._v(_vm._s(realIntention.answer1)),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  key: "real-intention-status-" + i,
                  staticClass: "realintention-right",
                },
                [
                  _c("span", { staticClass: "realintention-right" }, [
                    _vm._v(
                      "(" +
                        _vm._s(realIntention.gender.name) +
                        "/" +
                        _vm._s(realIntention.career) +
                        ")"
                    ),
                  ]),
                ]
              ),
            ]
          }),
          _vm._v(" "),
          _c("job-preview-button", {
            attrs: { title: "社員からの評判・口コミをすべて見る" },
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }